import * as React from "react";

export const GooglePlayCTA = () => (
  <svg
    width={135}
    height={40}
    viewBox="0 0 135 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M129.998 40H5.002A5.015 5.015 0 010 35V5c0-2.756 2.245-5 5.002-5h124.996A5.01 5.01 0 01135 5v30c0 2.746-2.248 5-5.002 5z"
      fill="#000"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M129.998.8c2.312 0 4.205 1.888 4.205 4.2v30c0 2.312-1.88 4.2-4.205 4.2H5.002A4.213 4.213 0 01.797 35V5c0-2.312 1.88-4.2 4.205-4.2h124.996zm0-.8H5.002A5.015 5.015 0 000 5v30c0 2.756 2.245 5 5.002 5h124.996A5.01 5.01 0 00135 35V5c0-2.746-2.248-5-5.002-5z"
      fill="#A6A6A6"
    />
    <path
      d="M71.118 13.232c-.901 0-1.661-.317-2.262-.94a3.209 3.209 0 01-.914-2.295c0-.91.308-1.68.914-2.291.598-.624 1.358-.94 2.26-.94.891 0 1.651.316 2.262.94.606.63.914 1.401.914 2.291-.01.913-.318 1.684-.914 2.292-.598.629-1.358.943-2.26.943zm-26.824 0a3.136 3.136 0 01-2.273-.928c-.62-.613-.936-1.389-.936-2.304 0-.915.315-1.69.936-2.304.614-.616 1.379-.928 2.273-.928.437 0 .861.087 1.269.264.4.172.725.407.966.694l.06.072-.674.663-.07-.082c-.38-.454-.888-.676-1.561-.676-.601 0-1.125.215-1.557.639-.435.426-.656.985-.656 1.66 0 .676.221 1.235.656 1.661.432.424.956.639 1.557.639.64 0 1.18-.215 1.6-.639.248-.25.401-.598.456-1.04h-2.158v-.932h3.084l.013.085c.022.157.045.319.045.468 0 .86-.259 1.556-.77 2.07-.582.609-1.341.918-2.26.918zM79.96 13.1h-.952l-2.913-4.681.025.843v3.835h-.951V6.9h1.085l.03.048 2.74 4.409-.026-.84V6.9h.962v6.2zm-15.99 0h-.963V7.833h-1.671V6.9h4.303v.933h-1.67V13.1h.002zm-3.42 0h-.96V6.9h.96v6.2zm-5.4 0h-.962V7.833h-1.671V6.9h4.303v.933h-1.67V13.1zm-3.242-.01h-3.685V6.9h3.685v.933h-2.722v1.7h2.456v.923h-2.456v1.701h2.722v.933zm17.653-1.44c.43.432.951.65 1.557.65.624 0 1.133-.213 1.557-.65.422-.423.636-.98.636-1.65 0-.67-.214-1.23-.633-1.65a2.126 2.126 0 00-1.557-.65c-.624 0-1.133.213-1.555.65-.422.423-.636.98-.636 1.65 0 .67.211 1.23.631 1.65z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M67.853 21.756c-2.347 0-4.25 1.788-4.25 4.254 0 2.444 1.915 4.254 4.25 4.254 2.347 0 4.25-1.8 4.25-4.254 0-2.466-1.903-4.254-4.25-4.254zm0 6.822c-1.284 0-2.39-1.067-2.39-2.578 0-1.534 1.108-2.579 2.39-2.579 1.284 0 2.389 1.045 2.389 2.579.002 1.521-1.105 2.578-2.39 2.578zm-9.271-6.822c-2.347 0-4.25 1.788-4.25 4.254 0 2.444 1.915 4.254 4.25 4.254 2.347 0 4.25-1.8 4.25-4.254 0-2.466-1.906-4.254-4.25-4.254zm0 6.822c-1.284 0-2.39-1.067-2.39-2.578 0-1.534 1.108-2.579 2.39-2.579 1.284 0 2.389 1.045 2.389 2.579 0 1.521-1.105 2.578-2.39 2.578zM47.55 23.055v1.8h4.304c-.132 1.01-.465 1.756-.974 2.267-.63.634-1.604 1.322-3.32 1.322-2.645 0-4.714-2.145-4.714-4.8 0-2.656 2.069-4.801 4.714-4.801 1.428 0 2.468.566 3.24 1.29l1.272-1.278c-1.073-1.032-2.5-1.823-4.502-1.823-3.629 0-6.673 2.968-6.673 6.601 0 3.644 3.042 6.601 6.673 6.601 1.96 0 3.43-.643 4.592-1.855 1.184-1.19 1.56-2.868 1.56-4.222 0-.421-.033-.8-.1-1.122h-6.075c.003-.003.003.02.003.02zm45.123 1.401c-.355-.955-1.428-2.71-3.628-2.71-2.18 0-3.994 1.723-3.994 4.254 0 2.389 1.793 4.254 4.205 4.254 1.937 0 3.065-1.19 3.53-1.887l-1.439-.968c-.477.71-1.14 1.177-2.081 1.177-.951 0-1.617-.434-2.059-1.29l5.665-2.356c0 .003-.199-.474-.199-.474zm-5.776 1.422c-.045-1.644 1.271-2.479 2.212-2.479.743 0 1.361.367 1.573.9l-3.785 1.579zM82.295 30h1.86V17.501h-1.86V30zm-3.055-7.3h-.067c-.42-.5-1.217-.954-2.235-.954-2.114 0-4.061 1.867-4.061 4.267 0 2.388 1.937 4.234 4.06 4.234 1.006 0 1.816-.456 2.236-.968h.067v.611c0 1.624-.864 2.499-2.258 2.499-1.14 0-1.847-.823-2.135-1.511l-1.617.678c.464 1.122 1.703 2.511 3.75 2.511 2.18 0 4.028-1.289 4.028-4.434V22H79.25v.7h-.01zm-2.136 5.878c-1.284 0-2.357-1.077-2.357-2.566 0-1.5 1.073-2.588 2.357-2.588 1.272 0 2.258 1.1 2.258 2.588.012 1.49-.984 2.566-2.258 2.566zm24.279-11.077h-4.448V30h1.86v-4.733h2.591c2.058 0 4.082-1.499 4.082-3.878s-2.016-3.888-4.085-3.888zm.055 6.02h-2.645v-4.29h2.645c1.393 0 2.18 1.155 2.18 2.145 0 .98-.797 2.145-2.18 2.145zm11.486-1.788c-1.351 0-2.744.601-3.32 1.91l1.649.689c.355-.689 1.005-.923 1.693-.923.964 0 1.938.579 1.96 1.61v.133c-.333-.19-1.063-.479-1.937-.479-1.781 0-3.586.978-3.586 2.81 0 1.68 1.46 2.756 3.087 2.756 1.249 0 1.937-.566 2.366-1.222h.067v.968h1.794v-4.788c0-2.23-1.65-3.464-3.773-3.464zm-.233 6.845c-.609 0-1.461-.299-1.461-1.067 0-.967 1.063-1.334 1.97-1.334.819 0 1.207.177 1.694.422a2.243 2.243 0 01-2.203 1.98zM123.238 22l-2.136 5.421h-.067L118.822 22h-2.001l3.32 7.578-1.892 4.213h1.937L125.295 22h-2.057zm-16.744 8h1.86V17.501h-1.86V30z"
      fill="#fff"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.391 7.534c-.288.311-.454.788-.454 1.411v22.112c0 .624.166 1.1.464 1.4l.077.067 12.338-12.39v-.276L10.468 7.466l-.077.068z"
      fill="url(#prefix__paint0_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.922 24.277l-4.115-4.132v-.29l4.115-4.132.09.055 4.867 2.778c1.393.788 1.393 2.09 0 2.888l-4.868 2.778-.09.055z"
      fill="url(#prefix__paint1_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.01 24.222L22.806 20 10.39 32.466c.454.49 1.217.544 2.068.068l14.551-8.312z"
      fill="url(#prefix__paint2_linear)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M27.01 15.778l-14.55-8.3c-.852-.488-1.617-.42-2.07.068L22.807 20l4.204-4.222z"
      fill="url(#prefix__paint3_linear)"
    />
    <path
      opacity={0.2}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.922 24.132L12.47 32.377c-.807.466-1.527.433-1.992.01l-.077.077.077.067c.465.422 1.185.457 1.992-.01l14.551-8.299-.1-.09z"
      fill="#000"
    />
    <path
      opacity={0.12}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.879 21.3l-4.97 2.832.09.09 4.867-2.778c.698-.4 1.04-.923 1.04-1.444-.041.479-.396.933-1.027 1.3z"
      fill="#000"
    />
    <path
      opacity={0.25}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.46 7.623l19.419 11.078c.63.356.985.823 1.04 1.299 0-.521-.343-1.045-1.04-1.444L12.459 7.48c-1.393-.8-2.522-.132-2.522 1.466v.145c0-1.601 1.13-2.257 2.523-1.467z"
      fill="#fff"
    />
    <defs>
      <linearGradient
        id="prefix__paint0_linear"
        x1={21.709}
        y1={8.707}
        x2={1.935}
        y2={13.954}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#00A0FF" />
        <stop offset={0.007} stopColor="#00A1FF" />
        <stop offset={0.26} stopColor="#00BEFF" />
        <stop offset={0.512} stopColor="#00D2FF" />
        <stop offset={0.76} stopColor="#00DFFF" />
        <stop offset={1} stopColor="#00E3FF" />
      </linearGradient>
      <linearGradient
        id="prefix__paint1_linear"
        x1={33.696}
        y1={20}
        x2={9.598}
        y2={20}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFE000" />
        <stop offset={0.409} stopColor="#FFBD00" />
        <stop offset={0.775} stopColor="orange" />
        <stop offset={1} stopColor="#FF9C00" />
      </linearGradient>
      <linearGradient
        id="prefix__paint2_linear"
        x1={24.724}
        y1={22.297}
        x2={8.761}
        y2={49.054}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF3A44" />
        <stop offset={1} stopColor="#C31162" />
      </linearGradient>
      <linearGradient
        id="prefix__paint3_linear"
        x1={7.264}
        y1={0.179}
        x2={14.386}
        y2={12.129}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#32A071" />
        <stop offset={0.069} stopColor="#2DA771" />
        <stop offset={0.476} stopColor="#15CF74" />
        <stop offset={0.801} stopColor="#06E775" />
        <stop offset={1} stopColor="#00F076" />
      </linearGradient>
    </defs>
  </svg>
);
